import { render, staticRenderFns } from "./TransferenciasPendentesSistema.vue?vue&type=template&id=7b1d55a0"
import script from "./TransferenciasPendentesSistema.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPendentesSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports